import React from "react";
import {Container, IntroPar, Box} from "../styles/intro_styles.js";
import {StartButton} from "../styles/stepper_styles.js";

export default function Introduction(props) {
  console.log('props intro', props.activeStep)
  return (
    <Container>
      <Box>
        <IntroPar>
        Online services are interested in solutions to opinion mining, which
        is the problem of extracting aspects, opinions, and sentiments from
        text. We describe Snippext, an opinion mining system developed over a
        language model that is fine-tuned through semi-supervised learning with
        augmented data. A novelty of Snippext is its clever use of a two-prong
        approach to achieve state-of-the-art (SOTA) performance with little
        labeled training data.
          <br />
          <br /> Go ahead and try it yourself!
          <br />
          <br />
        </IntroPar>
        {props.activeStep === -1 ? (
          <StartButton onClick={props.handleNext}>Start</StartButton>
        ) : (
          ""
        )}
      </Box>
    </Container>
  );
}

// <PubLink onclick="window.open('https://dl.acm.org/doi/10.1145/3431816','_blank')">
//   {" "}
//   Read our publication{" "}
// // </PubLink>
